<div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto">
        @if(!_orderWizardService.loading$()) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <corp-card class="h-full" [corp-content]="tp_corp_card_user_info"></corp-card>
</ng-template>

<ng-template #tp_corp_card_user_info>
    <div class="max-w-4xl mx-auto flex gap-2">
        @if(!hasCustomerExceptionCode() && !hasIdentityExceptionCode() && customerDto?.isScreeningOk && !customerDto?.isMailConfirmed){
            <!-- @if(!customerDto?.isMailConfirmed){ -->
            <button (click)="tab = 'emailValidation'"
                    class="px-4 py-2 rounded-tr-lg rounded-tl-lg flex items-center gap-1"
                    [ngClass]="tab === 'emailValidation'
                        ? 'bg-white text-gray-900'
                        : 'bg-gray-400 text-white'">
                <span class="material-symbols-outlined">mail</span>
                
                <!-- i18n: Email validation -->
                {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.button_01' | translate }}
            </button>

        }
        @if(customerDto?.isMailConfirmed && !customerDto?.isAskMailConfirmed) {
            <button (click)="tab = 'profile'"
                    class="px-4 py-2 rounded-tr-lg rounded-tl-lg flex items-center gap-1"
                    [ngClass]="tab === 'profile'
                        ? 'bg-white text-gray-900'
                        : 'bg-gray-400 text-white'">
                <span class="material-symbols-outlined">person</span>
                <!-- i18n: Profile -->
                {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.button_02' | translate }}
            </button>

            <button (click)="tab = 'identity'"
                    class="px-4 py-2 rounded-tr-lg rounded-tl-lg flex items-center gap-1"
                    [ngClass]="tab === 'identity'
                        ? 'bg-white text-gray-900'
                        : 'bg-gray-400 text-white'">
                <span class="material-symbols-outlined">badge</span>
                <!-- i18n: Identity -->
                {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.button_03' | translate }}
            </button>
        }
    </div>

@if(tab == 'exception'){
    <itsme-customer-exception-summary></itsme-customer-exception-summary>
}

@if(tab == 'emailValidation'){
    <itsme-email-validation></itsme-email-validation>
}

@if(tab == 'askEmailValidation') {
    <itsme-email-ask-validation></itsme-email-ask-validation>
}

@if(tab == 'profile'){
    <div class="max-w-4xl bg-white dark:bg-gray-900 rounded-tr-lg rounded-br-lg rounded-bl-lg shadow p-6 space-y-4">
        @if((businessCustomerExceptions?.length ?? 0)>0){
                <div class="flex items-center gap-2 text-sm text-danger-500">
                    <!-- i18n: Your ItsMe profile is incomplete. Please complete your pr... -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_01' | translate }}
                    <br>
                    @for(businessCustomerException of businessCustomerExceptions; track businessCustomerException) {
                        {{ businessCustomerException.code }} {{ businessCustomerException.label }} <br>
                    }
                </div>
        }
        
        <!-- Header -->
        <div class="flex items-center gap-4">

            <img src="images/products/itsme.svg" alt="user-image" class="w-20 h-20 rounded-full">
            <div class="flex-1">
                <h2 class="text-xl font-semibold text-gray-800 dark:text-white">
                    {{ customerDto?.firstName }} {{ customerDto?.lastName }}
                </h2>

                <div class="flex items-center gap-2 text-sm text-gray-500">
                    <span class="material-symbols-outlined text-base">mail</span>
                    {{ customerDto?.email }}
                    {{ customerDto?.isMailConfirmed }}
                    <!--email Verified badge -->
                    @if(customerDto?.isMailConfirmed){
                        <div class="flex items-center gap-1 px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs">
                            <span class="material-symbols-outlined text-sm">verified</span>
                            <!-- i18n: Email Verified -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_02' | translate }}
                        </div>
                    }
                    @else {
                        <div class="flex items-center gap-1 px-3 py-1 bg-danger-600 text-white rounded-full text-xs">
                            <span class="material-symbols-outlined text-sm">gpp_bad</span>
                            <!-- i18n: Email Not Verified -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_03' | translate }}
                        </div>
                    }

                </div>
            </div>
        </div>

        <!-- Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Personal -->
            <div class="section">
            <h3>
                <!-- i18n: Personal -->
                {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.h3_01' | translate }}
            </h3>

            <div class="info-item">
                <span class="material-symbols-outlined">person</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_CUST_003')">
                        <!-- i18n: Gender -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_01' | translate }}
                    </label>
                    <p>{{ customerDto?.gender }}</p>
                </div>
            </div>

            <div class="info-item">
                <span class="material-symbols-outlined">cake</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_CUST_006')">
                        <!-- i18n: Date of birth -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_02' | translate }}
                    </label>
                    <p>{{ customerDto?.dateOfBirth | date }}</p>
                </div>
            </div>

            <div class="info-item">
                <span class="material-symbols-outlined">location_on</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_CUST_009')">
                        <!-- i18n: Place of birth -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_03' | translate }}
                    </label>
                    <p>{{ customerDto?.placeOfBirth }}</p>
                </div>
            </div>

            <div class="info-item">
                <span class="material-symbols-outlined">flag</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_CUST_008')">
                        <!-- i18n: Nationality -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_04' | translate }}
                    </label>
                    <p>{{ customerDto?.nationality?.code }} {{ customerDto?.nationality?.label }}</p>
                </div>
            </div>

            <div class="info-item">
                <span class="material-symbols-outlined">language</span>
                <div>
                    <label>
                        <!-- i18n: Language -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_05' | translate }}
                    </label>
                    <p>{{ customerDto?.languageCode }}</p>
                </div>
            </div>
            </div>

            <!-- Contact -->
            <div class="section">
                <h3>
                    <!-- i18n: Contact -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.h3_02' | translate }}
                </h3>

                <div class="info-item">
                    <span class="material-symbols-outlined">mail</span>
                    <div>
                        <label [class.!text-danger-500]="hasExceptionCode('BUS_CUST_005')">
                            <!-- i18n: Email -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_06' | translate }}
                        </label>
                        <p>{{ customerDto?.email }}</p>
                    </div>
                </div>

                <div class="info-item">
                    <span class="material-symbols-outlined">call</span>
                    <div>
                        <label>
                            <!-- i18n: Phone -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_07' | translate }}
                        </label>
                        <p>{{ customerDto?.phone }}</p>
                    </div>
                </div>

                <div class="info-item">
                    <span class="material-symbols-outlined">home</span>
                    <div>
                        <label>
                            <!-- i18n: Address -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_08' | translate }}
                        </label>
                        <p>{{ customerDto?.address?.streetNumber }} {{ customerDto?.address?.streetName }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
   }

    @if(tab == 'identity'){
        <div class="max-w-4xl mx-auto bg-white dark:bg-gray-900 rounded-tr-lg rounded-br-lg rounded-bl-lg shadow p-6 space-y-4">
            @if((businessIdentityExceptions?.length ?? 0)>0){
                <div class="flex items-center gap-2 text-sm text-danger-500">
                    <!-- i18n: Your ItsMe profile is incomplete. Please complete your profile with the missi... -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_04' | translate }}
                    <br>
                    @for(businessCustomerException of businessCustomerExceptions; track businessCustomerException) {
                        {{ businessCustomerException.code }} {{ businessCustomerException.label }} <br>
                    }
                </div>
            }

            <div class="flex items-center justify-between">
                <h2 class="text-lg font-semibold text-gray-800 dark:text-white">
                    <!-- i18n: Identity Verification -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.h2_01' | translate }}
                </h2>

                @if(!customerDto?.isScreeningOk){
                    <div class="flex items-center gap-1 px-3 py-1 bg-danger-400 text-white rounded-full text-xs">
                        <span class="material-symbols-outlined text-sm">gpp_bad</span>
                        <!-- i18n: KYC NOT Verified -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_05' | translate }}
                    </div>
                }
                @else {
                    <div class="flex items-center gap-1 px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs">
                        <span class="material-symbols-outlined text-sm">verified_user</span>
                        <!-- i18n: KYC Verified -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.div_06' | translate }}
                    </div>
                }
                
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                <div class="info-item">
                <span class="material-symbols-outlined">badge</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_IDPROOF_006')">
                        <!-- i18n: Document type -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_09' | translate }}
                    </label>
                    <p>{{ customerDto?.identityProof?.idDocumentType }}</p>
                </div>
                </div>

                <div class="info-item">
                <span class="material-symbols-outlined">numbers</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_IDPROOF_003')">
                        <!-- i18n:  Document number -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_10' | translate }}
                    </label>
                    <p>{{ customerDto?.identityProof?.beNationalNumber }}</p>
                </div>
                </div>

                <div class="info-item">
                <span class="material-symbols-outlined">public</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_IDPROOF_008')">
                        <!-- i18n:  Issuing country -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_11' | translate }}
                    </label>
                    <p>{{ customerDto?.identityProof?.issuingCountry?.code }}</p>
                </div>
                </div>

                <div class="info-item">
                <span class="material-symbols-outlined">event</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_IDPROOF_004')">
                        <!-- i18n: Valid from -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_12' | translate }}
                    </label>
                    <p>{{ customerDto?.identityProof?.idDocumentIssuanceDate | date }}</p>
                </div>
                </div>

                <div class="info-item">
                <span class="material-symbols-outlined">event_available</span>
                <div>
                    <label [class.!text-danger-500]="hasExceptionCode('BUS_IDPROOF_005')">
                        <!-- i18n: Valid until -->
                        {{ 'i18n.app.features.pages.order.wizard.step_03.customer-summary.label_13' | translate }}
                    </label>
                    <p>{{ customerDto?.identityProof?.idDocumentExpiryDate | date }}</p>
                </div>
                </div>

            </div>
        </div>
    }


</ng-template>









